import Login from "../container/pages/Login";
import { SCREENS_IDS } from "./global-enums";
import Blogs from "../views/Blogs";

//Constants to set routes

const PublicRoutes = [
  {
    path: `/`,
    name: "login",
    component: Login,
  },
   {
    path: `/login`,
    name: "login",
    component: Login,
  },
];

const PrivateRoutes = [
   {
    screenId: SCREENS_IDS.EMPLOYEES,
    path: `/blogs`,
    name: "Blogs",
    icon: "ri-shield-user-fill",
    sortOrder: "",
    component: Blogs,
  },
];

const RouteConfig = { PublicRoutes, PrivateRoutes };
export default RouteConfig;
